<template>
  <TooltipPortal>
    <TooltipContent
      data-slot="tooltip-content"
      v-bind="{ ...forwarded, ...$attrs }"
      :class="cn(tooltipContentVariants({ color }), props.class)"
    >
      <slot />

      <TooltipArrow :class="tooltipContentArrowVariants({ color })" />
    </TooltipContent>
  </TooltipPortal>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import {
  TooltipArrow,
  TooltipContent,
  type TooltipContentEmits,
  type TooltipContentProps,
  TooltipPortal,
  useForwardPropsEmits,
} from "reka-ui";
import type { HTMLAttributes } from "vue";
import {
  type TooltipContentVariants,
  tooltipContentVariants,
  tooltipContentArrowVariants,
} from "./variants";
import { cn } from "@/lib/utils";

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<
    TooltipContentProps & {
      color?: TooltipContentVariants["color"];
      class?: HTMLAttributes["class"];
    }
  >(),
  {
    sideOffset: 4,
    color: "default",
    class: undefined,
  },
);

const emits = defineEmits<TooltipContentEmits>();

const delegatedProps = reactiveOmit(props, "class");
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
